module.exports = __webpack_public_path__ + "static/media/a-weekend-in-verona.ea8ccff0.md";